// Library Methods
import i18next from "i18next";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import dashboardPageImg from "src/assets/images/operating-manual/portal-overview/dashboard.png";
import dashboardPageFrImg from "src/assets/images/operating-manual/portal-overview/dashboard-fr.png";

// Config
import { priorityLanguageMap } from "src/config/languages";

const DashboardPage = () => {
  const { t } = useTranslation("operating-manual");

  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  const portalText = [
    {
      title: t("Navigation Bar"),
      content: t(
        "Navigate to the dashboard page, patient page, switch between clincs, and view your profile options."
      ),
    },
    {
      title: t("Clinic Stats"),
      content: t("View clinic usage over time."),
    },
    {
      title: t("Device Section"),
      content: t(
        "View and manage your devices. Each device has a name, exam status (linked / not linked to exam, and the name the exam is linked to), connection status (offline, online), and battery percentage."
      ),
    },
    {
      title: t("Today"),
      content: t("View and link exams scheduled for today."),
    },
    {
      title: t("Recently Completed"),
      content: t(
        "View recently completed exams completed today or in the last 7 days."
      ),
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={currentLang === "fr" ? dashboardPageFrImg : dashboardPageImg}
          width="85%"
          alt="headset"
        />
      </Box>

      <Box
        sx={{
          padding: "20px",
          borderRadius: "8px",
          backgroundColor: "#5B6D7A30",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {portalText.map((portalItem, index) => (
            <Grid
              container
              key={portalItem.title}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <Typography fontSize="14px" fontWeight={600}>
                {index + 1}. {portalItem.title}
              </Typography>
              <Typography fontSize="14px">{portalItem.content}</Typography>
            </Grid>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardPage;
